"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SupportId = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const SupportId = ({
  supportId
}) => {
  if (!supportId) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
    id: "support-id",
    children: ["Support ID: ", supportId]
  });
};
exports.SupportId = SupportId;
